// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"4b7b3e5f","225":"6d3f89a0","272":"c4d47d2c","372":"b5d574b5","377":"8d410cf8","572":"36f92e9d","573":"f9fd1b09","738":"2ea5b528","841":"5a4bf57b","856":"6a339590"}[chunkId] + ".chunk.js";
};